import React, { useState, useEffect } from "react";
import Circles from "../components/Circles";
import Footer from "../components/Footer";
import Nav from "../components/Nav";
import req from "../images/req.png";
import axios from "axios";
import { server_API } from "../config";
const RequestDemo = () => {
  const [fname, setFname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [organization, setOrganization] = useState("");
  const [message, setMessage] = useState("");
  const [validEmail, setValidEmail] = useState(true);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const submit = () => {
    if (email.length > 0 && email.includes("@")) {
      const domain = email.split("@")[1];
      if (
        domain.includes("gmail") ||
        domain.includes("yahoo") ||
        domain.includes("hotmail")
      ) {
        setValidEmail(false);
      } else {
        setValidEmail(true);
        axios
          .post(`${server_API}/v2/company/earlyaccess`, {
            name: fname,
            email: email,
            phone: phone,
            org: organization,
            message: message,
          })
          .then((response) => {
            console.log(response);
            alert("Thank you, we will get in touch with you soon!");
          })
          .catch((error) => {
            console.log(error);
            alert("Something went wrong, please try again later");
          });
      }
    }
  };

  return (
    <div className="font-poppins">
      <Nav></Nav>
      <div className="my-10 md:px-40 px-5 md:py-20 relative overflow-x-clip ">
        <div className="md:grid grid-cols-2 gap-6 items-center">
          <div>
            <p className="text-2xl font-extrabold">Request a demo</p>
            <p className="text-xl mt-4">
              Write to us and we will reach out to you with a solution that fits
              your needs:
            </p>
            <div className="mt-5 flex flex-col space-y-5">
              <div>
                <p>
                  Full name <span className="text-red-500">*</span>
                </p>
                <input
                  value={fname}
                  onChange={(e) => {
                    setFname(e.target.value);
                  }}
                  className="px-2 mt-2 rounded-xl outline-none border py-2 w-full"
                ></input>
              </div>
              <div>
                <p>
                  Email <span className="text-red-500">*</span>
                </p>
                <input
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  className="px-2 mt-2 rounded-xl outline-none border py-2 w-full"
                ></input>
                {!validEmail && <p>Please enter a business email address</p>}
              </div>
              <div>
                <p>
                  Phone No. <span className="text-red-500">*</span>
                </p>
                <input
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                  className="px-2 mt-2 rounded-xl outline-none border py-2 w-full"
                ></input>
              </div>
              <div>
                <p>
                  Organization<span className="text-red-500">*</span>
                </p>
                <input
                  value={organization}
                  onChange={(e) => {
                    setOrganization(e.target.value);
                  }}
                  className="px-2 mt-2 rounded-xl outline-none border py-2 w-full"
                ></input>
              </div>
              <div>
                <p>
                  Your message <span className="text-red-500">*</span>
                </p>
                <textarea
                  rows="3"
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                  className="px-2 mt-2 rounded-xl outline-none border py-2 w-full"
                ></textarea>
              </div>
              <button
                className="bg-[#148EFF] text-white bg-opacity-150 py-3 rounded-xl"
                onClick={() => {
                  submit();
                }}
              >
                Submit
              </button>
            </div>
          </div>
          <div className=" overflow-x-clip">
            <Circles color="#148EFF2E" className="absolute right-0 top-1/2" />
            <img src={req} className="h-[30rem] md:block hidden mx-auto"></img>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RequestDemo;
